var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class MiniQuestionSuccessionScore {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get mini() {
        return this.parent;
    }
    get app() {
        return this.mini.app;
    }
    /* Scoring */
    get scoreTotal() {
        const totalScore = this.scoreSuccession;
        return Math.round(totalScore);
    }
    /*
    get scoreLeastOftenShown(): number {
      if (this.mini.miniPassState.questionState === QuestionPassStateId.New) return 1000000;
      if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed) return -1000000;
      if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed2) return -10000000;
      if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed3) return -100000000;
      return 0;
    }*/
    get scoreSuccession() {
        return 100000 - this.mini.micro.successionIndex;
    }
}
__decorate([
    computed
], MiniQuestionSuccessionScore.prototype, "scoreTotal", null);
